import { Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import type { MRT_ColumnDef, MRT_RowData } from "mantine-react-table-open";
import { MantineIconCell } from "../../../../../../mantine/mrt/components/cell/MantineIconCell";
import { THEME_VARS } from "../../../../../../utils/constants";
import { getMeterTableErrorText } from "../getMeterTableErrorText";

export function getLocationFeedoutColumn<T extends MRT_RowData>({
  errorText,
  onChange,
  getCellError
}: {
  errorText?: string | null;
  onChange?: (value: MRT_RowData) => void;
  getCellError: (
    rowIndex: number,
    accessorKey: keyof T
  ) => Array<string> | null | undefined;
}): MRT_ColumnDef<T> {
  return {
    accessorKey: "location_feedout",
    header: "Mess- oder Marktlokation Entnahme",
    mantineEditTextInputProps: ({ row }) => ({
      disabled: row.original.source === "pvPlant",
      error: errorText,
      onChange: () => onChange?.(row)
    }),
    Cell: ({ row }) => {
      const cellError = getCellError(row.index, "location_feedout");
      return (
        <div>
          {row.original.location_feedout}
          {cellError && (
            <MantineIconCell
              iconColor={THEME_VARS.error[6]}
              IconComponent={IconAlertTriangle}
              renderedCellValue={
                <Text c="error">{getMeterTableErrorText(cellError[0])}</Text>
              }
            />
          )}
        </div>
      );
    }
  };
}
